'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function BlockDisable(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 16 16' }, props),
    React.createElement(
      'g',
      { stroke: 'none', 'stroke-width': '1', fillRule: 'evenodd' },
      React.createElement(
        'g',
        { transform: 'translate(-53.000000, -228.000000)' },
        React.createElement(
          'g',
          { transform: 'translate(53.000000, 134.000000)' },
          React.createElement(
            'g',
            { id: 'Group-8', transform: 'translate(0.000000, 94.000000)' },
            React.createElement('path', { d: 'M2,9 L5,9 C5.55228475,9 6,9.44771525 6,10 L6,13 C6,13.5522847 5.55228475,14 5,14 L2,14 C1.44771525,14 1,13.5522847 1,13 L1,10 C1,9.44771525 1.44771525,9 2,9 L2,9 Z M2,2 L5,2 C5.55228475,2 6,2.44771525 6,3 L6,6 C6,6.55228475 5.55228475,7 5,7 L2,7 C1.44771525,7 1,6.55228475 1,6 L1,3 L1,3 C1,2.44771525 1.44771525,2 2,2 L2,2 Z M11.2071068,1.67157288 L13.3284271,3.79289322 C13.7189514,4.18341751 13.7189514,4.81658249 13.3284271,5.20710678 L11.2071068,7.32842712 C10.8165825,7.71895142 10.1834175,7.71895142 9.79289322,7.32842712 L7.67157288,5.20710678 C7.28104858,4.81658249 7.28104858,4.18341751 7.67157288,3.79289322 L9.79289322,1.67157288 L9.79289322,1.67157288 C10.1834175,1.28104858 10.8165825,1.28104858 11.2071068,1.67157288 L11.2071068,1.67157288 Z M9,9 L12,9 C12.5522847,9 13,9.44771525 13,10 L13,13 C13,13.5522847 12.5522847,14 12,14 L9,14 C8.44771525,14 8,13.5522847 8,13 L8,10 C8,9.44771525 8.44771525,9 9,9 Z' })
          )
        )
      )
    )
  );
}
BlockDisable.displayName = 'BlockDisable';

module.exports = BlockDisable;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/blockDisable.js
// module id = 153
// module chunks = 0